const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')

const statuses = ['pending', 'dismissed', 'acknowledged']

const shape = labelify({
  resort: yup.mixed(),
  status: yup.string().oneOf(statuses).ensure().default('pending'),
  profile: yup.mixed(),
  acknowledgedAt: yup.date(),
  acknowledgedBy: yup.mixed(),
  dismissedAt: yup.date(),
  dismissedUntil: yup.date(),
  type: yup.string(),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const serviceRequestSchemaPartial = yup.object().shape(shape)
const serviceRequestSchema = serviceRequestSchemaPartial.shape(requiredFields(['name'])(shape))

module.exports = { serviceRequestSchema, serviceRequestSchemaPartial }
